import React, { useState, useMemo, useEffect, useContext, useRef } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  FlatList,
  StyleSheet,
  PixelRatio,
  Dimensions,
  Platform,
  ActivityIndicator,
  Modal,
  ScrollView,
  TextInput,
  Pressable,
} from "react-native";
import { Image } from "expo-image";
import { MaterialCommunityIcons, Ionicons } from "@expo/vector-icons";
import * as Google from "expo-auth-session/providers/google";
import Colours from "../../../utils/Colours"; // Adjust path based on your utilities file setup
import TopHeaderComponent from "../../aTopHeader/TopHeaderComponent";
import AppleSignin from "react-apple-signin-auth";
import {
  useNavigation,
  useRoute,
  useIsFocused,
  useNavigationContainerRef,
} from "@react-navigation/native";
import axios, { axiosWithCredentials } from "../../../api/axios";
import ErrorAlertComp from "../../../alertComp/ErrorAlertComp";
import SuccessAlertComp from "../../../alertComp/SuccessAlertComp";
import AppContext from "../../../context/AppContext";
import useAuth from "../../../hooks/useAuth";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import * as AuthSession from "expo-auth-session";
import { SafeAreaView } from "react-native-safe-area-context";

const { width, height } = Dimensions.get("window");

// --- RESPONSIVE TOOLKIT ---
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  return Math.round(PixelRatio.roundToNearestPixel(size * scaleFactor));
};
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const BrandMenuPrepaid = () => {
  const { setAuth, setActivitySettings, setUserInfo, isLoggedIn, auth } = useContext(AppContext);
  const { sub, email, phoneNumber } = useAuth();
  const isFocused = useIsFocused();
  const [allMenuItems, setAllMenuItems] = useState([]);

  const navigation = useNavigation();
  const route = useRoute();
  const axiosPrivate = useAxiosPrivate();

  // 1. Read individual primitive identifiers directly from the URL route safely
  const tableId = route.params?.tableId;
  const isTopUp = route.params?.isTopUp;
  // const { isTopUp } = route.params || {};

  const { currentTier, tableAnonymity, promoterId, venueId, showId, isReserved } =
    route.params || {};

  const [selectedPaymentChoice, setSelectedPaymentChoice] = useState(null); // 'NOW' or 'LATER'

  const [publicCategories, setPublicCategories] = useState(["All"]);

  const [tableDataUpdate, setTableDataUpdate] = useState();
  const [menuItems, setMenuItems] = useState([]);
  const [showData, setShowData] = useState(null);
  const [isCartExpanded, setIsCartExpanded] = useState(false);
  const [isProcessOrderLoading, setIsProcessOrderLoading] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [brandMeta, setBrandMeta] = useState(null); // Local state container for company styling
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [cart, setCart] = useState({}); // Shape: { [item._id]: quantity }
  //   const [isLoadingMenue, setIsLoadingMenue] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isAuthLoading, setIsAuthLoading] = useState(false);

  // Auth verification state controls
  const [isAuthModalVisible, setIsAuthModalVisible] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [isLoadingOTP, setIsLoadingOTP] = useState(false);

  const [showChoosePayment, setShowChoosePayment] = useState(false);

  // const userHasValidCredentials = !!(user?.email || user?.phoneNumber);
  // const userHasValidCredentials = !!email;
  const userHasValidCredentials = !!(email || phoneNumber);

  const shouldAutoOrder = useRef(false);
  const navigationRef = useNavigationContainerRef();

  // Then on focus, check the ref

  //   useEffect(() => {
  //     if (!tableId) return;
  //     // //console.log("userCREDENTIALS", phoneNumber, email);

  //     const fetchScreenRequirements = async () => {
  //       if (!tableId) return;

  //       try {
  //         setIsLoading(true);

  //         // Step 1: Fetch the table context details (with populated associatedBrand)
  //         const tableResponse = await axios.get(`/tableDetailsPublic/tableDetailsPublic/${tableId}`);
  //         const tableData = tableResponse.data.tableData;

  //         setTableDataUpdate(tableData);

  //         //console.log("tableDatttta", tableResponse.data);

  //         // Update your brand layout state using the populated data
  //         setBrandMeta(tableData?.associatedBrand);

  //         // Extract the specific brand ID from the populated object
  //         const brandId = tableData?.associatedBrand?._id || tableData?.associatedBrand;

  //         if (brandId) {
  //           // Step 2: Fetch menu items based on the Brand ID and the active category selector
  //           const menuResponse = await axios.get("/getMenuItemsPublic/getMenuItemsPublic", {
  //             params: {
  //               associatedBrand: brandId,
  //               // category: selectedCategory, // "All", "Drinks", etc.
  //             },
  //           });

  //           //console.log("menuResponseDatta", menuResponse.data);

  //           // Step 3: Set items to state. The rendering layer switches between item.regularPrice
  //           // and item.doingsPrice instantly on the frontend based on your URL's 'currentTier' parameter!
  //           let serverItems = Array.isArray(menuResponse.data)
  //             ? menuResponse.data
  //             : menuResponse.data?.data || [];
  //           // setMenuItems(serverItems.filter((item) => item.isAvailable !== false));
  //           serverItems = serverItems.filter((item) => item.isAvailable !== false);

  //           // if (selectedCategory === "All" && Array.isArray(tableData?.orders)) {
  //           if (Array.isArray(tableData?.orders || [])) {
  //             const preferenceMap = {};

  //             // Traverse through all order batches on this active table
  //             tableData.orders.forEach((batch) => {
  //               if (Array.isArray(batch.items)) {
  //                 batch.items.forEach((orderedItem) => {
  //                   // Safely extract the target ID string from the Schema definition
  //                   const itemIdStr = orderedItem.menuItemId?._id || orderedItem.menuItemId;
  //                   if (itemIdStr) {
  //                     // Accumulate total quantity ordered across batches
  //                     preferenceMap[itemIdStr.toString()] =
  //                       (preferenceMap[itemIdStr.toString()] || 0) + (orderedItem.quantity || 1);
  //                   }
  //                 });
  //               }
  //             });

  //             // Sort descending: higher historical quantities float to the top
  //             serverItems.sort((a, b) => {
  //               const idA = (a._id || a.id)?.toString();
  //               const idB = (b._id || b.id)?.toString();
  //               const countA = preferenceMap[idA] || 0;
  //               const countB = preferenceMap[idB] || 0;
  //               return countB - countA;
  //             });
  //           }

  //           // Hydrate React state elements safely
  //           setAllMenuItems(serverItems);
  //           setMenuItems(serverItems);

  //           if (serverItems.length > 0) {
  //             const extractedCategories = [
  //               "All",
  //               ...new Set(serverItems.map((item) => item.category).filter(Boolean)),
  //             ];
  //             setPublicCategories(extractedCategories);
  //           }
  //         }
  //       } catch (error) {
  //         console.error("PWA reload hydration breakdown:", error);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     };

  //     fetchScreenRequirements();
  //     // }, [tableId, selectedCategory]);
  //   }, [tableId]);

  useEffect(() => {
    if (!showId) return;

    const fetchScreenRequirements = async () => {
      try {
        setIsLoading(true);

        const response = await axios.get("/getMenuItemsPublic/getMenuItemsPublic", {
          params: { showId },
        });

        // Extract populated show details and menu items
        const showDetails = response.data?.showData || null;
        let items = Array.isArray(response.data) ? response.data : response.data?.data || [];

        // Filter available items only
        items = items.filter((item) => item.isAvailable !== false);

        // Hydrate state
        setShowData(showDetails);
        setAllMenuItems(items);
        setMenuItems(items);

        // Extract categories
        if (items.length > 0) {
          const extractedCategories = [
            "All",
            ...new Set(items.map((item) => item.category).filter(Boolean)),
          ];
          setPublicCategories(extractedCategories);
        }
      } catch (error) {
        console.error("Error fetching show menu items:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchScreenRequirements();
  }, [showId]);

  useEffect(() => {
    if (selectedCategory === "All") {
      setMenuItems(allMenuItems);
    } else {
      // Perform an instant local client filter without hitting the server
      const filtered = allMenuItems.filter((item) => item.category === selectedCategory);
      setMenuItems(filtered);
    }
  }, [selectedCategory, allMenuItems]);

  // --- 5. DYNAMIC PRICE RESOLUTION & TOTAL CALCULATIONS ---
  const { totalItems, totalPrice } = useMemo(() => {
    return menuItems.reduce(
      (acc, item) => {
        const currentId = item._id || item.id;
        const qty = cart[currentId] || 0;

        // RESOLVE TIER PRICE: Select correct schema field dynamically
        const resolvedUnitPrice = currentTier === "doings" ? item.doingsPrice : item.regularPrice;

        return {
          totalItems: acc.totalItems + qty,
          totalPrice: acc.totalPrice + qty * (resolvedUnitPrice || 0),
        };
      },
      { totalItems: 0, totalPrice: 0 },
    );
  }, [cart, menuItems, currentTier]);

  const [request, response, promptAsync] = Google.useAuthRequest({
    // 1. For Expo Go or Web testing
    // webClientId: "607742650924-4qvotvu1q75g3a9dchind088c87pmpco.apps.googleusercontent.com",
    webClientId: "607742650924-2ei9go2bl635sl9gh1pakdj2rqr3s0kn.apps.googleusercontent.com",

    // 2. For your physical iPhone build
    iosClientId: "607742650924-mbcms1rms9i91dj5l9cdp4143lgua83c.apps.googleusercontent.com",

    // 3. For your Android build
    androidClientId: "607742650924-k779l559pl0hjfse5a2kch7cqh5j71jf.apps.googleusercontent.com",

    // redirectUri: Platform.OS === "web" ? "https://app.getmeeza.com" : undefined,
    // redirectUri: Platform.OS === "web" ? "http://localhost:8081/" : undefined,
    redirectUri: AuthSession.makeRedirectUri({
      scheme: "http",
      // host: '127.0.0.1', // Swap from localhost to loopback IP
      host: "localhost", //  Swap from localhost to loopback IP
      port: 8081,
      path: "", // Explicitly forces NO trailing slash
    }),
  });

  useEffect(() => {
    if (response?.type === "success") {
      const { authentication } = response;
      const { accessToken } = authentication;

      executeGoogleOrderProcessingPipeline(accessToken);
    }
  }, [response]);

  // 3. Fallback layout indicators to protect UI during cold starts
  if (isLoading || isAuthLoading) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
      </View>
    );
  }
  //   // Reused brand UI layout fallback fields
  //   const brandName = brandMeta?.brandName || "The Venue";
  //   const brandAddress = brandMeta?.brandAddress || "Location Details Not Set";
  //   const brandImage = brandMeta?.image || "https://placehold.co/150";

  // 2. Component Core Operational State Engines
  //   const [menuItems, setMenuItems] = useState([]); // Database items replace array

  // --- 4. CART QUANTITY MANAGEMENT ENGINE ---
  const handleUpdateQuantity = (itemId, action) => {
    setCart((prevCart) => {
      const currentQty = prevCart[itemId] || 0;
      const nextCart = { ...prevCart };

      if (action === "add") {
        nextCart[itemId] = currentQty + 1;
      } else if (action === "subtract" && currentQty > 0) {
        nextCart[itemId] = currentQty - 1;
        if (nextCart[itemId] === 0) delete nextCart[itemId];
      }
      return nextCart;
    });
  };

  const handleBackNavigation = () => {
    // const isLoggedIn = !!userToken; // Check if user has a token
    const loggedIn = !!sub; // If 'sub' exists, they have a valid access token in memory
    const isWeb = Platform.OS === "web";

    console.log("SUB", sub);

    if (isWeb && !loggedIn) {
      navigation.navigate("getStarted");
    } else if (loggedIn && auth?.isProfileComplete === true) {
      navigation.navigate("main");
    } else {
      // Token exists but profile/order isn't complete yet — main isn't mounted.
      // Fall back to something that's guaranteed to exist in this state.
      navigation.goBack();
    }
  };

  const handlePlaceOrder = () => {
    const checkTopUp = isTopUp || sessionStorage.getItem("is_topup_flow") === "true";
    console.log("checkTopUpppp", checkTopUp);
    if (!userHasValidCredentials) {
      setIsAuthModalVisible(true);
      return;
    } else if (checkTopUp) {
      //setShowChoosePayment(true);
      executeOrderProcessingPrivatePipelineTopUp();
      console.log("I am in Top up");
    } else {
      //New Table while logged in
      executeOrderProcessingPrivatePipeline();
    }
  };

  //For new Tables
  const processPostPaymentSelection = (choice) => {
    // A. Close the selection screen
    setShowChoosePayment(false);

    // B. Save what they clicked in case we need to show the Auth Modal
    setSelectedPaymentChoice(choice);

    // C. VALIDATION SECURITY CHECK
    if (!userHasValidCredentials) {
      // Drop anchor! If they aren't logged in, intercept and show auth sheet
      setIsAuthModalVisible(true);
      return;
    }

    // D. User is logged in! Run the correct pipeline based on their account type
    if (sub) {
      console.log("PRIVIIVIV");
      executeOrderProcessingPrivatePipeline(); //- used for TopUps
    } else {
      console.log("hsnhhHHHH");

      executeOrderProcessingPipeline();
    }
  };

  const handleAppleSuccess = async (response) => {
    // Apple returns:
    // response.authorization.id_token
    // response.user (ONLY sent on the FIRST login)

    const appleCredential = {
      identityToken: response.authorization?.id_token,
      user: response.user || null,
    };

    console.log("appleCredential", appleCredential);

    // Pass it directly to your pipeline function
    await executeAppleOrderProcessingPipeline(appleCredential);
  };

  const handleAppleFailure = (error) => {
    console.error("Apple Sign-In Error:", error);
  };

  async function executeGoogleOrderProcessingPipeline(googleAuthToken) {
    if (isProcessOrderLoading) return;

    try {
      setIsProcessOrderLoading(true);

      // STEP 1: Process Google Guest Identity Authentication First
      const authResponse = await axiosWithCredentials.post("/googleGuestAuth/googleGuestAuth", {
        googleToken: googleAuthToken,
      });

      // const { accessToken } = authResponse.data;
      const strictLocalToken = authResponse.data.accessToken;

      // Immediately flag that we are entering an intentional checkout sequence
      // setAuth({
      //   accessToken,
      //   isProfileComplete: true,
      //   hasPendingPrepaidOrder: true, // Intercepts AppNav routing to hit PayForTable screen!
      // });
      // setIsAuthModalVisible(false);

      console.log("Are we Here Yet");
      // STEP 2: Map and structure the item totals for payment initialization request setup
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;
        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
        };
      });

      // .reduce() loops over finalOrderItems, multiplying qty * price, adding it to a rolling sum
      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log("Calculated Order Total Amount:", paymentAmount);

      // if (navigation) {
      //   navigation.navigate("payForTable");
      // } else if (navigationRef?.isReady()) {
      //   // Fallback fallback pointer case reference alternative if passed globally
      //   navigationRef.navigate("payForTable");
      // }

      console.log("No Forced routing to payment flow triggered.");

      // return;
      //----Run step 3 before..-----//
      // STEP 3: Request the checkout intent payload token link from the backend
      // Since we set the new accessToken in auth state, your intercepted credential configuration hooks will attach it
      const checkoutSetup = await axiosWithCredentials.post(
        "/payments2/initialize-checkout",
        {
          tableId,
          items: finalOrderItems,
          tableAnonymity,
        },
        {
          headers: { Authorization: `Bearer ${strictLocalToken}` },
        },
      );

      if (checkoutSetup.data.status === "success") {
        const targetUrl = checkoutSetup.data.data.checkoutUrl;
        setAuth({
          accessToken: strictLocalToken,
          isProfileComplete: true,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
        });

        console.log("Success or Failure Test");

        setIsAuthModalVisible(false);
        setCart({});

        // Redirect out to Monnify Web Gateway Interface
        // window.location.href = targetUrl;
      }
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.message || "Failed to finalize pipeline. Verify inputs.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  async function executeAppleOrderProcessingPipeline(appleCredential) {
    if (isProcessOrderLoading) return;

    try {
      setIsProcessOrderLoading(true);

      // Extract identity token and raw user object (if present) from Apple credential response
      const { identityToken, user } = appleCredential;

      // STEP 1: Process Apple Guest Identity Authentication First
      const authResponse = await axiosWithCredentials.post("/appleGuestAuth/appleGuestAuth", {
        id_token: identityToken,
        rawUser: user, // Sent by Apple SDK on initial sign-in
      });

      const strictLocalToken = authResponse.data.accessToken;

      console.log("Apple Guest Auth Successful");

      // STEP 2: Map and structure the item totals for payment initialization request setup
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;
        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
        };
      });

      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log("Calculated Order Total Amount:", paymentAmount);

      // STEP 3: Request the checkout intent payload token link from the backend
      const checkoutSetup = await axiosWithCredentials.post(
        "/payments2/initialize-checkout",
        {
          tableId,
          items: finalOrderItems,
          tableAnonymity,
        },
        {
          headers: { Authorization: `Bearer ${strictLocalToken}` },
        },
      );

      if (checkoutSetup.data.status === "success") {
        const targetUrl = checkoutSetup.data.data.checkoutUrl;

        setAuth({
          accessToken: strictLocalToken,
          isProfileComplete: true,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
        });

        console.log("Apple Checkout Pipeline Completed Successfully");

        setIsAuthModalVisible(false);
        setCart({});

        // Redirect to Payment Gateway (e.g., Monnify)
        // window.location.href = targetUrl;
      }
    } catch (error) {
      console.error("Apple Order Pipeline Failure:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to finalize pipeline. Verify inputs.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  //Mostly for users using phone number
  async function executeOrderProcessingPipeline() {
    //console.log("1. pipeline entered");
    if (isProcessOrderLoading) return;
    // 1. Structural safety validation
    //console.log("2. past loading guard");
    if (!tableId || Object.keys(cart).length === 0) {
      //console.log("3. BAILED - tableId:", tableId, "cart:", cart);

      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return;
    }

    //console.log("4. past cart/table guard - proceeding to request");

    try {
      // 2. Map items perfectly to match the backend embedded sub-document array rules
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId, // Maps to schema menuItemId
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          totalItemPrice: (targetPrice || 0) * cart[cartId], // Required by your backend ledger hook
          menuType: currentTier, // ENUM: "regular" or "doings"
        };
      });

      // 3. Build order payload tailored for your table batch schema push
      // We send this as a new order batch object ready for an array update
      const newOrderPayload = {
        orderTotalAmount: totalPrice,
        status: "pending", // Schema default fallback setting
        items: finalOrderItems,
        phoneNumber: whatsappNumber,
        tableAnonymity,
      };

      //console.log("Transmitting transactional package to backend endpoint:", newOrderPayload);
      //console.log("Transmitting transmmut:", finalOrderItems);
      setIsProcessOrderLoading(true);
      // 4. Send network request to append the order to the virtual table
      // Assuming your endpoint updates a table, e.g., POST or PATCH to /tables/${tableId}/orders
      //Mostly Phone numbersBased
      const response = await axiosWithCredentials.post(
        `/createTableOrderPublic/createTableOrderPublic/${tableId}`,
        {
          ...newOrderPayload,
        },
      );

      //console.log("this here");

      if (response.status === 200 || response.status === 201) {
        const { accessToken, user, isProfileComplete } = response.data;

        console.log("AccessT", accessToken, "isProfileComp", isProfileComplete);

        setAuth({ accessToken, isProfileComplete });

        // Store profile traits and server configurations if returned in the response
        // if (guestUser) setUserInfo(guestUser);
        // if (activitySettings) setActivitySettings(activitySettings);
        // setTableData(tableData);

        setSuccessMessage(`Order placed in ${currentTier.toUpperCase()} Mode! Processing items.`);
        setIsSuccessCompVisible(true);
        setCart({}); // Flash clean state wipe upon completion
      }
    } catch (error) {
      console.error("Order dispatch communication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit order. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  async function executeOrderProcessingPrivatePipeline() {
    if (isProcessOrderLoading) return;

    console.log("");

    // // 1. Structural safety validation
    // if (!tableId || !showId || Object.keys(cart).length === 0) {
    //   setErrorMessage("Your cart is empty or no existing show or table.");
    //   setIsErrorCompVisible(true);
    //   return;
    // }

    // 1. Structural safety validation
    if ((!tableId && !showId) || Object.keys(cart).length === 0) {
      setErrorMessage("Your cart is empty or no valid show or table selection was found.");
      setIsErrorCompVisible(true);
      return;
    }

    try {
      setIsProcessOrderLoading(true);

      // STEP 2: Map items perfectly to match the backend initialization array format
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          // Optional tracking sub-properties depending on your server-side map parsing
          totalItemPrice: (targetPrice || 0) * cart[cartId],
          menuType: currentTier,
        };
      });

      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log("Calculated Private Order Total Amount:", paymentAmount);

      // STEP 3: Request the checkout intent payload token link from the backend
      // Utilizing axiosPrivate ensures current access credentials from context pass automatically
      const checkoutSetup = await axiosPrivate.post("/payments2/initialize-checkout", {
        tableId,
        showId,
        isReservedOrder: isReserved,
        items: finalOrderItems,
        tableAnonymity,
        phoneNumber: whatsappNumber, // Folded in from local configuration input
      });

      if (checkoutSetup.data.status === "success") {
        // STEP 4: Store flags locally to pass state monitoring to PayForTable screen intercepts
        setAuth((prev) => ({
          ...prev,
          isProfileComplete: true,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,

          reference: checkoutSetup.data?.data?.reference,
        }));

        console.log("Private checkout sequence initialized successfully.");

        // Clean local workspace state
        setCart({});

        // If you use an explicit modal/component wrapper configuration layer, hide it here:
        // setIsAuthModalVisible(false);
      } else {
        setErrorMessage("Gateway initialization rejection.");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      console.error("Order dispatch communication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit order. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  async function executeOrderProcessingPrivatePipelineTopUp() {
    if (isProcessOrderLoading) return;

    // 1. Structural safety validation
    if (!tableId || Object.keys(cart).length === 0) {
      setErrorMessage("Your cart is empty or the table context is missing.");
      setIsErrorCompVisible(true);
      return;
    }

    try {
      setIsProcessOrderLoading(true);

      // STEP 2: Map items perfectly to match the backend initialization array format
      const finalOrderItems = Object.keys(cart).map((cartId) => {
        const findItem = menuItems.find((m) => (m._id || m.id) === cartId);
        const targetPrice =
          currentTier === "doings" ? findItem?.doingsPrice : findItem?.regularPrice;

        return {
          menuItemId: cartId,
          name: findItem?.name || "Unknown Item",
          quantity: cart[cartId],
          unitPrice: targetPrice || 0,
          // Optional tracking sub-properties depending on your server-side map parsing
          totalItemPrice: (targetPrice || 0) * cart[cartId],
          menuType: currentTier,
        };
      });

      const paymentAmount = finalOrderItems.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);

      console.log("Calculated Private Order Total Amount:", paymentAmount);

      // STEP 3: Request the checkout intent payload token link from the backend
      // Utilizing axiosPrivate ensures current access credentials from context pass automatically
      const checkoutSetup = await axiosPrivate.post("/payments2/initialize-checkout-topUp", {
        tableId,
        items: finalOrderItems,
        tableAnonymity,
        phoneNumber: whatsappNumber, // Folded in from local configuration input
      });

      if (checkoutSetup.data.status === "success") {
        // STEP 4: Store flags locally to pass state monitoring to PayForTable screen intercepts
        console.log("Teating hasPendingOrder", checkoutSetup.data?.hasPendingPrepaidOrder);
        sessionStorage.removeItem("is_topup_flow");
        setAuth((prev) => ({
          ...prev,
          isProfileComplete: true,
          hasPendingPrepaidOrder: checkoutSetup.data?.hasPendingPrepaidOrder,
          pendingOrderDetails: checkoutSetup.data?.pendingOrderDetails,
        }));

        console.log("Private checkout sequence initialized successfully.");

        // Clean local workspace state
        setCart({});

        // If you use an explicit modal/component wrapper configuration layer, hide it here:
        // setIsAuthModalVisible(false);
      } else {
        setErrorMessage("Gateway initialization rejection.");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      console.error("Order dispatch communication error:", error);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit order. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsProcessOrderLoading(false);
    }
  }

  // Check if every item in the list has a valid image string
  const allHaveImages =
    menuItems.length > 0 && menuItems.every((item) => item.image && item.image.trim() !== "");

  if (isProcessOrderLoading) {
    return (
      <View
        style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "#fff" }}
      >
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
        <Text style={{ marginTop: dynamicSpacing(15), fontFamily: "Sen-Bold", color: "#1A1A1A" }}>
          {/* Sending order to kitchen... */}
          Connecting to payment gateway...
        </Text>
      </View>
    );
  }

  return (
    <SafeAreaView style={styles.safeArea}>
      {isLoading ? (
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
          <ActivityIndicator size="large" color={Colours.PRIMARY} />
        </View>
      ) : (
        /* 🌟 WRAPPER VIEW: Ensures children flex and stack correctly */
        <View style={styles.screenWrapper}>
          {/* 📌 FIXED TOP HEADER */}
          <View style={styles.fixedHeader}>
            <TopHeaderComponent
              headerText={"Explore Menu"}
              hideScreen={() => {
                if (navigation.canGoBack()) {
                  navigation.goBack();
                } else {
                  navigation.navigate("chooseSpendModePrepaid", { showId });
                }
              }}
            />
          </View>

          {/* DYNAMIC SCROLLER */}
          <View style={styles.scrollArea}>
            <FlatList
              data={menuItems}
              keyExtractor={(item) => item._id || item.id}
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{
                paddingBottom: totalItems > 0 ? dynamicSpacing(140) : dynamicSpacing(40),
              }}
              /* 🌟 CLEAN SCROLLABLE HEADER ELEMENTS */
              ListHeaderComponent={
                <View
                  style={{
                    paddingHorizontal: dynamicSpacing(20),
                    paddingTop: dynamicSpacing(10),
                  }}
                >
                  {/* 🎭 SHOW HERO & DETAILS CARD */}
                  <View style={styles.showHeroCard}>
                    {/* Show Cover Image */}
                    <Image
                      source={{
                        uri: showData?.image || brandImage || "https://placehold.co/600x300",
                      }}
                      style={styles.showCoverImage}
                      contentFit="cover"
                      cachePolicy="disk"
                    />

                    <View style={styles.showCardBody}>
                      {/* Show Caption / Title */}
                      {showData?.caption ? (
                        <Text style={styles.showCaptionText} numberOfLines={2}>
                          {showData.caption}
                        </Text>
                      ) : null}

                      {/* Host Venue & Promoter Meta Row */}
                      <View style={styles.metaRowContainer}>
                        {/* Host Venue */}
                        <View style={styles.metaBadge}>
                          <Ionicons
                            name="location-outline"
                            size={dynamicSize(14)}
                            color={Colours.PRIMARY}
                          />
                          <Text style={styles.metaLabelText} numberOfLines={1}>
                            Venue:{" "}
                            <Text style={styles.metaValueText}>
                              {showData?.hostVenue?.brandName || "Host Venue"}
                            </Text>
                          </Text>
                        </View>

                        {/* Promoter */}
                        <View style={styles.metaBadge}>
                          <Ionicons
                            name="person-outline"
                            size={dynamicSize(14)}
                            color={Colours.PRIMARY}
                          />
                          <Text style={styles.metaLabelText} numberOfLines={1}>
                            Headliner:{" "}
                            <Text style={styles.metaValueText}>
                              {showData?.promoter?.brandName || "Promoter"}
                            </Text>
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>

                  {/* CATEGORY TABS */}
                  <View style={{ marginBottom: dynamicSpacing(15) }}>
                    <FlatList
                      data={publicCategories}
                      horizontal
                      showsHorizontalScrollIndicator={false}
                      keyExtractor={(item) => item}
                      renderItem={({ item }) => {
                        const isActive = selectedCategory === item;
                        return (
                          <TouchableOpacity
                            onPress={() => setSelectedCategory(item)}
                            style={[styles.categoryTab, isActive && styles.activeCategoryTab]}
                          >
                            <Text
                              style={[
                                styles.categoryTabText,
                                isActive && styles.activeCategoryTabText,
                              ]}
                            >
                              {item}
                            </Text>
                          </TouchableOpacity>
                        );
                      }}
                    />
                  </View>
                </View>
              }
              ListEmptyComponent={() => (
                <View style={{ alignItems: "center", marginTop: 40 }}>
                  <Text style={{ color: "#8E8E93" }}>
                    No available items found in this section.
                  </Text>
                </View>
              )}
              //   renderItem={({ item }) => {
              //     const currentId = item._id || item.id;
              //     const quantity = cart[currentId] || 0;
              //     const activePriceDisplay =
              //       currentTier === "doings" ? item.doingsPrice : item.regularPrice;

              //     return (
              //       <View style={[styles.menuItemCard, { marginHorizontal: dynamicSpacing(20) }]}>
              //         <Image
              //           source={{ uri: item.image || showData?.image || brandImage }}
              //           style={styles.menuItemImage}
              //           contentFit="cover"
              //         />
              //         <View style={styles.menuItemDetails}>
              //           <Text style={styles.menuItemName} numberOfLines={2}>
              //             {item.name}
              //           </Text>
              //           <Text style={styles.menuItemPrice}>
              //             ₦{activePriceDisplay ? activePriceDisplay.toLocaleString() : "0"}
              //           </Text>
              //         </View>
              //         <View style={styles.counterContainer}>
              //           {quantity > 0 && (
              //             <>
              //               <TouchableOpacity
              //                 onPress={() => handleUpdateQuantity(currentId, "subtract")}
              //                 style={styles.counterBtn}
              //               >
              //                 <Ionicons
              //                   name="remove"
              //                   size={dynamicSize(16)}
              //                   color={Colours.PRIMARY}
              //                 />
              //               </TouchableOpacity>
              //               <Text style={styles.counterText}>{quantity}</Text>
              //             </>
              //           )}
              //           <TouchableOpacity
              //             onPress={() => handleUpdateQuantity(currentId, "add")}
              //             style={[styles.counterBtn, { backgroundColor: Colours.PRIMARY }]}
              //           >
              //             <Ionicons name="add" size={dynamicSize(16)} color="white" />
              //           </TouchableOpacity>
              //         </View>
              //       </View>
              //     );
              //   }}
              renderItem={({ item }) => {
                const currentId = item._id || item.id;
                const quantity = cart[currentId] || 0;
                const activePriceDisplay =
                  currentTier === "doings" ? item.doingsPrice : item.regularPrice;

                // -------------------------------------------------------------
                // NO-IMAGE LAYOUT MODE (Triggered if 1 or more items lack an image)
                // -------------------------------------------------------------
                if (!allHaveImages) {
                  return (
                    <View
                      style={[styles.compactMenuItemCard, { marginHorizontal: dynamicSpacing(20) }]}
                    >
                      <View style={styles.compactMenuItemDetails}>
                        <Text style={styles.menuItemName} numberOfLines={1}>
                          {item.name}
                        </Text>

                        {/* Description support */}
                        {!!item.description && (
                          <Text style={styles.menuItemDescription} numberOfLines={2}>
                            {item.description}
                          </Text>
                        )}

                        <Text style={styles.menuItemPrice}>
                          ₦{activePriceDisplay ? activePriceDisplay.toLocaleString() : "0"}
                        </Text>
                      </View>

                      {/* Action / Counter Buttons */}
                      <View style={styles.counterContainer}>
                        {quantity > 0 && (
                          <>
                            <TouchableOpacity
                              onPress={() => handleUpdateQuantity(currentId, "subtract")}
                              style={styles.counterBtn}
                            >
                              <Ionicons
                                name="remove"
                                size={dynamicSize(16)}
                                color={Colours.PRIMARY}
                              />
                            </TouchableOpacity>
                            <Text style={styles.counterText}>{quantity}</Text>
                          </>
                        )}
                        <TouchableOpacity
                          onPress={() => handleUpdateQuantity(currentId, "add")}
                          style={[styles.counterBtn, { backgroundColor: Colours.PRIMARY }]}
                        >
                          <Ionicons name="add" size={dynamicSize(16)} color="white" />
                        </TouchableOpacity>
                      </View>
                    </View>
                  );
                }

                // -------------------------------------------------------------
                // FULL IMAGE LAYOUT MODE (Only when ALL items have valid images)
                // -------------------------------------------------------------
                return (
                  <View style={[styles.menuItemCard, { marginHorizontal: dynamicSpacing(20) }]}>
                    <Image
                      source={{ uri: item.image }}
                      style={styles.menuItemImage}
                      contentFit="cover"
                    />
                    <View style={styles.menuItemDetails}>
                      <Text style={styles.menuItemName} numberOfLines={1}>
                        {item.name}
                      </Text>

                      {/* Description support */}
                      {!!item.description && (
                        <Text style={styles.menuItemDescription} numberOfLines={2}>
                          {item.description}
                        </Text>
                      )}

                      <Text style={styles.menuItemPrice}>
                        ₦{activePriceDisplay ? activePriceDisplay.toLocaleString() : "0"}
                      </Text>
                    </View>

                    <View style={styles.counterContainer}>
                      {quantity > 0 && (
                        <>
                          <TouchableOpacity
                            onPress={() => handleUpdateQuantity(currentId, "subtract")}
                            style={styles.counterBtn}
                          >
                            <Ionicons
                              name="remove"
                              size={dynamicSize(16)}
                              color={Colours.PRIMARY}
                            />
                          </TouchableOpacity>
                          <Text style={styles.counterText}>{quantity}</Text>
                        </>
                      )}
                      <TouchableOpacity
                        onPress={() => handleUpdateQuantity(currentId, "add")}
                        style={[styles.counterBtn, { backgroundColor: Colours.PRIMARY }]}
                      >
                        <Ionicons name="add" size={dynamicSize(16)} color="white" />
                      </TouchableOpacity>
                    </View>
                  </View>
                );
              }}
            />
          </View>

          {/* 📌 FIXED CHECKOUT DRAWER: Placed completely outside the FlatList layout tree */}
          {totalItems > 0 && (
            <View
              style={[
                styles.checkoutStickyContainer,
                {
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: "#ffffff",
                  borderTopWidth: 1,
                  borderTopColor: "#EAEAEA",
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: -3 },
                  shadowOpacity: 0.1,
                  shadowRadius: 5,
                  elevation: 10,
                },
              ]}
            >
              {/* 🌟 EXPANDABLE BASKET DETAILS CONTAINER */}
              {isCartExpanded && (
                <View
                  style={{
                    padding: dynamicSpacing(20),
                    borderBottomWidth: 1,
                    borderBottomColor: "#F5F5F7",
                    maxHeight: dynamicSize(250),
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      marginBottom: dynamicSpacing(10),
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "Sen-Bold",
                        fontSize: dynamicFontSize(16),
                        color: "#1A1A1A",
                      }}
                    >
                      Review Selected Items
                    </Text>
                    <TouchableOpacity onPress={() => setIsCartExpanded(false)}>
                      <Ionicons name="chevron-down" size={dynamicSize(20)} color="#8E8E93" />
                    </TouchableOpacity>
                  </View>

                  <ScrollView showsVerticalScrollIndicator={true} nestedScrollEnabled={true}>
                    {Object.keys(cart).map((cartId) => {
                      const itemMatch = menuItems.find((m) => (m._id || m.id) === cartId);
                      const itemQty = cart[cartId];
                      if (itemQty <= 0 || !itemMatch) return null;

                      const itemPrice =
                        currentTier === "doings" ? itemMatch.doingsPrice : itemMatch.regularPrice;

                      return (
                        <View
                          key={cartId}
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            paddingVertical: dynamicSpacing(8),
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: dynamicSpacing(8),
                              flex: 1,
                              paddingRight: dynamicSpacing(10),
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Sen-Bold",
                                color: Colours.PRIMARY,
                                fontSize: dynamicFontSize(14),
                              }}
                            >
                              {itemQty}x
                            </Text>
                            <Text
                              style={{ color: "#333", fontSize: dynamicFontSize(14) }}
                              numberOfLines={1}
                            >
                              {itemMatch.name}
                            </Text>
                          </View>
                          <Text
                            style={{
                              fontFamily: "Sen-Bold",
                              color: "#1A1A1A",
                              fontSize: dynamicFontSize(14),
                            }}
                          >
                            ₦{((itemPrice || 0) * itemQty).toLocaleString()}
                          </Text>
                        </View>
                      );
                    })}
                  </ScrollView>
                </View>
              )}

              {/* CORE ACTION SUB-BAR */}
              <View style={styles.priceRowContainer}>
                {/* Clicking this side toggles the itemized scroll overlay drawer */}
                <TouchableOpacity
                  activeOpacity={0.7}
                  onPress={() => setIsCartExpanded(!isCartExpanded)}
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: dynamicSpacing(6),
                  }}
                >
                  <View>
                    <Text style={styles.basketCountText}>
                      {totalItems} {totalItems === 1 ? "item" : "items"} selected
                    </Text>
                    <Text style={styles.basketTotalValue}>₦{totalPrice.toLocaleString()}</Text>
                  </View>
                  <Ionicons
                    name={isCartExpanded ? "chevron-down" : "chevron-up"}
                    size={dynamicSize(16)}
                    color={Colours.PRIMARY}
                    style={{ marginTop: dynamicSpacing(12) }}
                  />
                </TouchableOpacity>
                {console.log("RESERV", isReserved)}
                <TouchableOpacity style={styles.proceedBtn} onPress={handlePlaceOrder}>
                  {isProcessOrderLoading ? (
                    <ActivityIndicator size="large" color="white" />
                  ) : (
                    <Text style={styles.proceedBtnText}>
                      {isReserved ? "Make Reserved Order" : "Place Order"}
                    </Text>
                  )}
                  <MaterialCommunityIcons
                    name="silverware-fork-knife"
                    size={dynamicSize(18)}
                    color="white"
                  />
                </TouchableOpacity>
              </View>
            </View>
          )}
        </View>
      )}

      {/* ── PAYSTACK SYSTEM LEVEL INTEGRATION NOTICE ALERT OVERLAY ── */}
      <Modal visible={showChoosePayment} transparent={true} animationType="fade">
        <View style={styles.alertModalCenteredBackdrop}>
          <View style={styles.alertModalContainerBox}>
            <View style={styles.alertIconHeaderContainer}>
              <MaterialCommunityIcons name="shield-check" size={32} color={Colours.PRIMARY} />
            </View>
            <Text style={styles.alertModalHeading}>Confirm Bill Total</Text>
            {/* <Text style={styles.alertModalHeading}>Choose to pay</Text> */}

            <Text style={styles.alertModalMessage}>
              {/* You can choose to pay now or after the fun is over, your total sum is {"\n"} */}
              You are about to pay a total sum of {"\n"}
              <Text style={styles.alertModalAmountHighlight}>
                ₦{totalPrice ? totalPrice.toLocaleString() : "0"}
              </Text>
            </Text>

            <View style={styles.alertModalButtonWrapper}>
              <TouchableOpacity
                style={styles.alertModalCancelButton}
                // onPress={executePaymentGatewayPayload}
                onPress={() => {
                  setShowChoosePayment(false);
                }}
              >
                <Text style={styles.alertModalCancelText}>Cancel</Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={styles.alertModalOkButton}
                onPress={() => {
                  processPostPaymentSelection("LATER");
                }}
              >
                <Text style={styles.alertModalOkText}>Pay Now</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* 🔒 AUTHENTICATION CHECK BOTTOM SHEET MODAL */}
      <Modal
        visible={isAuthModalVisible}
        transparent
        animationType="slide"
        onRequestClose={() => setIsAuthModalVisible(false)}
      >
        {/* Semi-transparent backdrop blur wrapper */}
        <View
          style={{ flex: 1, backgroundColor: "rgba(0, 0, 0, 0.5)", justifyContent: "flex-end" }}
        >
          {/* 🌟 Backdrop Dismiss Target: Covers only the empty top area */}
          <TouchableOpacity
            style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
            activeOpacity={1}
            onPress={() => setIsAuthModalVisible(false)}
          />

          {/* 🌟 FIXED SHEET CONTAINER PANEL: Switched to Pressable with event isolation */}
          <Pressable
            onPress={(e) => e.stopPropagation()} //  Prevents click event leakage from closing the modal
            style={{
              backgroundColor: "white",
              borderTopLeftRadius: dynamicSize(24),
              borderTopRightRadius: dynamicSize(24),
              paddingHorizontal: dynamicSpacing(24),
              paddingTop: dynamicSpacing(16),
              paddingBottom: dynamicSpacing(40),
              maxHeight: "80%",
              width: "100%",
              zIndex: 10,
            }}
          >
            {/* Top Drag Indicator Notch */}
            <View
              style={{
                width: 40,
                height: 5,
                backgroundColor: "#E5E5EA",
                borderRadius: 3,
                alignSelf: "center",
                marginBottom: dynamicSpacing(20),
              }}
            />
            <Text
              style={{
                fontFamily: "Sen-Bold",
                fontSize: dynamicFontSize(20),
                color: "#1A1A1A",
                textAlign: "center",
                marginBottom: dynamicSpacing(6),
              }}
            >
              {/* Almost done pleeease */}
              Important for payments
            </Text>
            <Text
              style={{
                fontSize: dynamicFontSize(14),
                color: "#666",
                textAlign: "center",
                marginBottom: dynamicSpacing(24),
              }}
            >
              Your Identity will help us process your orders and payments effectively, thank you.
              {/* To send your order to the kitchen and save your digital receipt, quickly secure your
              profile */}
            </Text>
            {/* OAUTH SSO BUTTON CONTAINER CLUSTER */}
            <View style={{ gap: dynamicSpacing(12), marginBottom: dynamicSpacing(24) }}>
              <TouchableOpacity
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  borderWidth: 1,
                  borderColor: "#E5E5EA",
                  borderRadius: dynamicSize(12),
                  paddingVertical: dynamicSpacing(14),
                }}
                onPress={() => promptAsync({ useProxy: true })}
              >
                <Ionicons name="logo-google" size={20} color="#EA4335" />
                {/* <Image
                  source={{
                    uri: "https://developers.google.com/identity/images/g-logo.png",
                  }}
                  style={styles.googleIcon}
                /> */}
                <Text
                  style={{
                    fontFamily: "Sen-Bold",
                    fontSize: dynamicFontSize(15),
                    color: "#1A1A1A",
                  }}
                >
                  Continue with Google
                </Text>
              </TouchableOpacity>

              <AppleSignin
                authOptions={{
                  // clientId: "com.mexa.pwa", // Your registered Apple Services
                  clientId: "com.meeeza.pwa",
                  scope: "email name",
                  redirectURI: "https://app.getmeeza.com/",
                  // redirectURI: "https://getmeeza.com/prollix/appleAuth/appleAuth", // Must match Apple Developer Portal
                  usePopup: true, // Prevents page reload so cart state remains intact
                }}
                onSuccess={handleAppleSuccess}
                onError={handleAppleFailure}
                render={(props) => (
                  <TouchableOpacity
                    // disabled={true}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 10,
                      backgroundColor: "#000",
                      borderRadius: dynamicSize(12),
                      paddingVertical: dynamicSpacing(14),
                    }}
                    onPress={props.onClick}
                  >
                    <Ionicons name="logo-apple" size={20} color="white" />
                    <Text
                      style={{
                        fontFamily: "Sen-Bold",
                        fontSize: dynamicFontSize(15),
                        color: "white",
                      }}
                    >
                      Continue with Apple
                    </Text>
                  </TouchableOpacity>
                )}
              />
            </View>
          </Pressable>
        </View>
      </Modal>

      {/* MODAL OVERLAY PORTAL */}
      <Modal visible={isErrorCompVisible} transparent animationType="fade">
        <ErrorAlertComp
          message={errorMessage}
          onClose={() => {
            setCart({});
            setIsErrorCompVisible(false);
          }}
        />
      </Modal>
      <Modal visible={isSuccessCompVisible} transparent animationType="fade">
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            setCart({});
            setIsSuccessCompVisible(false);
            handleBackNavigation();
          }}
        />
      </Modal>
    </SafeAreaView>
  );
};

export default BrandMenuPrepaid;

// --- STYLING PATTERNS ARCHITECTURE ---
const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: "#F9F9FA",
    // On web, SafeAreaView doesn't constrain height by default
    ...(Platform.OS === "web" && {
      height: "100vh",
      overflow: "hidden",
    }),
  },
  scrollArea: {
    flex: 1,
    overflow: "hidden",
  },

  // Re-used identical structural brand card configurations
  brandHeroCard: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    padding: dynamicSpacing(16),
    borderRadius: dynamicSize(16),
    marginBottom: dynamicSpacing(20),
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
  },
  brandImage: {
    width: dynamicSize(64),
    height: dynamicSize(64),
    borderRadius: dynamicSize(12),
    backgroundColor: "#F5F5F7",
  },
  brandMetaInfo: {
    flex: 1,
    marginLeft: dynamicSpacing(15),
    justifyContent: "center",
  },
  nameTxt: {
    color: Colours.DARKGRAY || "#1A1A1A",
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
    marginBottom: dynamicSpacing(2),
  },
  emailTxt: {
    color: "#666",
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
    lineHeight: dynamicFontSize(16),
  },
  screenWrapper: {
    flex: 1,
    overflow: "hidden",
  },
  fixedHeader: {
    backgroundColor: "#fff",
    zIndex: 1000,
  },
  googleIcon: {
    width: dynamicSize(20),
    height: dynamicSize(20),
    marginRight: dynamicSpacing(12),
  },
  // Menu Category items
  categoryTab: {
    paddingHorizontal: dynamicSpacing(16),
    paddingVertical: dynamicSpacing(8),
    borderRadius: dynamicSize(20),
    backgroundColor: "#EBEBEF",
    marginRight: dynamicSpacing(10),
  },
  activeCategoryTab: {
    backgroundColor: Colours.PRIMARY,
  },
  categoryTabText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(13),
    color: "#555",
  },
  activeCategoryTabText: {
    color: "white",
  },

  // Menu List cards
  menuItemCard: {
    flexDirection: "row",
    backgroundColor: "white",
    padding: dynamicSpacing(12),
    borderRadius: dynamicSize(14),
    alignItems: "center",
    marginBottom: dynamicSpacing(12),
    borderWidth: 1,
    borderColor: "#F0F0F2",
  },
  menuItemImage: {
    width: dynamicSize(65),
    height: dynamicSize(65),
    borderRadius: dynamicSize(10),
    backgroundColor: "#F5F5F7",
  },
  menuItemDetails: {
    flex: 1,
    marginLeft: dynamicSpacing(12),
    paddingRight: dynamicSpacing(8),
  },
  menuItemName: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(14),
    color: "#222",
    marginBottom: dynamicSpacing(4),
  },
  menuItemPrice: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
    color: Colours.PRIMARY,
  },

  // Counter Elements
  counterContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F5F5F7",
    borderRadius: dynamicSize(20),
    padding: dynamicSpacing(4),
    gap: dynamicSpacing(8),
  },
  counterBtn: {
    width: dynamicSize(28),
    height: dynamicSize(28),
    borderRadius: dynamicSize(14),
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
    elevation: 1,
  },
  counterText: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(14),
    color: "#222",
    minWidth: dynamicSpacing(16),
    textAlign: "center",
  },

  // Footer Placement Panel
  checkoutStickyContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
    paddingHorizontal: dynamicSpacing(20),
    paddingTop: dynamicSpacing(15),
    paddingBottom: Platform.OS === "ios" ? dynamicSpacing(35) : dynamicSpacing(20),
    borderTopLeftRadius: dynamicSize(20),
    borderTopRightRadius: dynamicSize(20),
    elevation: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    zIndex: 1000,
  },
  priceRowContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  basketCountText: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
    color: "gray",
  },
  basketTotalValue: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(22),
    color: "#222",
  },
  proceedBtn: {
    backgroundColor: Colours.PRIMARY,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: dynamicSpacing(24),
    height: dynamicSize(50),
    borderRadius: dynamicSize(14),
    gap: dynamicSpacing(8),
  },
  proceedBtnText: {
    color: "white",
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(15),
  },

  /* ── CUSTOM PAYSTACK NOTICE POPUP STYLES ── */
  alertModalCenteredBackdrop: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  alertModalContainerBox: {
    width: "100%",
    maxWidth: 320,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 24,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
  },
  alertIconHeaderContainer: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: "#FFF4F2",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },
  alertModalHeading: {
    fontFamily: "Sen-Bold",
    fontSize: 18,
    color: "#1A1A1A",
    marginBottom: 8,
    textAlign: "center",
  },
  alertModalMessage: {
    fontFamily: "Sen-Regular",
    fontSize: 14,
    color: "#555",
    textAlign: "center",
    lineHeight: 22,
    marginBottom: 24,
  },
  alertModalAmountHighlight: {
    fontFamily: "Sen-Bold",
    fontSize: 20,
    color: Colours.PRIMARY,
  },
  alertModalButtonWrapper: {
    flexDirection: "row",
    width: "100%",
    gap: 12,
  },
  alertModalCancelButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 10,
    backgroundColor: "#F5F5F5",
    alignItems: "center",
    justifyContent: "center",
  },
  alertModalCancelText: {
    fontFamily: "Sen-Bold",
    fontSize: 14,
    color: "#666",
  },
  alertModalOkButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 10,
    backgroundColor: Colours.PRIMARY,
    alignItems: "center",
    justifyContent: "center",
  },
  alertModalOkText: {
    fontFamily: "Sen-Bold",
    fontSize: 14,
    color: "white",
  },

  showHeroCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: dynamicSpacing(16),
    overflow: "hidden",
    marginBottom: dynamicSpacing(20),
    elevation: 3,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
  },
  showCoverImage: {
    width: "100%",
    height: dynamicSpacing(160),
  },
  showCardBody: {
    padding: dynamicSpacing(14),
  },
  showCaptionText: {
    fontSize: dynamicSize(16),
    fontWeight: "700",
    color: "#1C1C1E",
    marginBottom: dynamicSpacing(10),
  },
  metaRowContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: dynamicSpacing(8),
  },
  metaBadge: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F2F2F7",
    paddingHorizontal: dynamicSpacing(10),
    paddingVertical: dynamicSpacing(6),
    borderRadius: dynamicSpacing(20),
    gap: dynamicSpacing(4),
  },
  metaLabelText: {
    fontSize: dynamicSize(12),
    color: "#8E8E93",
    fontWeight: "500",
  },
  metaValueText: {
    color: "#1C1C1E",
    fontWeight: "600",
  },

  // Styles for description text (used in both layouts)
  menuItemDescription: {
    fontSize: dynamicSize(12),
    color: "#8E8E93",
    marginTop: dynamicSpacing(2),
    marginBottom: dynamicSpacing(4),
    lineHeight: dynamicSize(16),
  },

  // Compact Layout (No Images)
  compactMenuItemCard: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#FFFFFF",
    borderRadius: dynamicSpacing(12),
    padding: dynamicSpacing(14),
    marginBottom: dynamicSpacing(10),
    // Elevation / Shadow
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 2,
  },
  compactMenuItemDetails: {
    flex: 1,
    paddingRight: dynamicSpacing(10),
  },
});
